import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import AppRouter from './router';
import { ErrorBoundary } from './core/errors';

export default function App() {
    return (
        <ErrorBoundary>
            {/* ToastProvider now wraps everything from main.jsx. */}
            <BrowserRouter>
                <AppRouter />
            </BrowserRouter>
        </ErrorBoundary>
    );
}
